import styled from 'styled-components'

export const StyledCard = styled.div`
  padding: ${({theme}) => theme.spacing.lg};
  border-radius: ${({theme}) => theme.borderRadius.sm};
  box-shadow: ${({theme}) => theme.boxShadow.card};
  background-color: ${({theme}) => theme.colors.white};
`
